import React, { useEffect, useMemo } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import { Box, Image, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { toggleBGM } from "../../../redux/action/action";
import useCheckLogin from "../../../hook/useCheckLogin";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const LoginButton = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);

  const { isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: "45px",
      md: "55px",
      xl: isMachineUser ? "55px" : "55px",
    };
  }, [isMachineUser]);

  return (
    <Box
      as={Link}
      to="signin"
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      height={iconSize}
      w={{
        base: "80px",
        md: "100px",
      }}
      bgImage={`url('${COMMON_WEB_PATH}/theOne/header/uid_banner.png')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100%100%"
    >
      <Text
        fontWeight={"bold"}
        fontSize={{
          base: "18px",
          md: "24px",
        }}
        textShadow={"0 0 1.5px white"}
      >
        {i18n_header("signin")}
      </Text>
    </Box>
  );
};

export default LoginButton;
